// extracted by css-extract-rspack-plugin
export default {"cls1":"SingularMentionCitationModal-cls1_gMa","cls2":"SingularMentionCitationModal-cls2_Xyt SingularMentionCitationModal-cls1_gMa"};